import FulfillmentProductCreatePage from "./FulfillmentProductCreatePage";
export default FulfillmentProductCreatePage;
